var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSunscreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13772_58356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.00156 0.132812C3.78125 0.132812 3.60156 0.3125 3.60156 0.532813C3.60156 0.942188 3.60625 1.33906 3.61406 1.73281H16.3891C16.3969 1.34062 16.4016 0.942188 16.4016 0.532813C16.4016 0.3125 16.2234 0.132812 16.0016 0.132812H4.00156ZM3.63906 2.53281C3.87031 9.51406 5.25781 13.8563 5.81406 15.3328H14.1891C14.7469 13.8578 16.1344 9.53438 16.3641 2.53281H3.63906ZM8.40156 6.93281H11.6016V10.1328H8.40156V6.93281ZM6.00156 16.1328V18.9328C6.00156 19.5938 6.54062 20.1328 7.20156 20.1328H12.8016C13.4625 20.1328 14.0016 19.5938 14.0016 18.9328V16.1328H6.00156Z",
    fill: "#272A34"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13772_58356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.132812)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSunscreen);
export default __webpack_public_path__ + "static/media/Sunscreen.3aa04d754bd9d4783a0df333c8117e76.svg";
export { ForwardRef as ReactComponent };